<div class="my-day-component-container">
    <h2 class="widget-header h4">
        <span i18n="my day title@@my-day-title" class="widget-header my-day-title text-center">Today</span>&nbsp;<span class="header-todays-date"><abbr title="{{today}}">{{today | formatDate:false}}</abbr></span>
    </h2>
    <h3 class="text-muted h6" i18n="my day sub title@@my-day-sub-title">
        Here is a list of all your assigned tasks and booked meetings for today. Tasks with a due date up to one week ahead are listed.
    </h3>


    <div class="my-day-wrapper mt-4 d-md-flex">

        <!-- tasks -->
        <mat-accordion *ngIf="tasks && tasks.length" class="left mr-2 w-50">
            <div class="d-md-flex justify-content-start mb-md-3">
                <span class="mr-1" i18n="@@your-day-tasks-from">Tasks from </span>
                <app-action-link [href]="plannerLink" [target]="'blank'">
                    <span i18n="@@your-day-planner">Planner</span>
                </app-action-link>
                <span class="ml-1 mr-1" i18n="@@your-day-and">and</span>
                <app-action-link [href]="todoLink" [target]="'blank'">
                  <span  i18n="@@your-day-todo">To do</span>
                </app-action-link>
            </div>
            <mat-expansion-panel *ngFor="let task of tasks | slice:0:showMore; let i = index" class="task mb-3" [class.outlook]="task.Type === 0">
                <mat-expansion-panel-header [class.completed]="task.Status === 2">
                    <mat-panel-title>
                        <div>
                            <i [ngClass]="[
                   task.Status === 2 ? 'mr-2 fa fa-check-circle-o task-icon' : 'mr-2 fa fa-list-ul task-icon'
                   ]" aria-hidden="true"></i>
                            <span class="mr-2 font-weight-bold" *ngIf="task.DueDateFormatted"><abbr title="{{task.DueDateFormatted | formatDate:false}}">{{task.DueDateFormatted | formatDate:false}}</abbr></span>
                            <span data-hj-suppress>{{task.Subject}}</span>
                        </div>
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <div class="task-type">
                        <app-action-link *ngIf="task.Type === 0" [href]="todoLink" [target]="'_blank'">
                            <span i18n="my day todo tasks link@@my-day-todo-tasks-link">To Do</span>
                        </app-action-link>
                        <app-action-link *ngIf="task.Type === 1" [href]="plannerLink" [target]="'_blank'">
                            <span i18n="my day planner link@@my-day-planner-link">Planner</span>
                        </app-action-link>
                    </div>
                    <div class="task-details mt-2">
                        <ng-container *ngIf="task.Type === 0">
                            <span *ngIf="task.Body && task.Body.length > 0" [innerHTML]="task.Body"></span>
                        </ng-container>
                        <ng-container *ngIf="task.Type === 1">
                            <div *ngIf="task.PlannerPlan$ | async as plan" data-hj-suppress><span class="font-weight-bold">Plan: </span>{{plan.title}}</div>
                            <div *ngIf="task.PlannerBucket$ | async as bucket"><span class="font-weight-bold">Bucket: </span>{{bucket.name}}</div>
                            <div *ngIf="task.PlannerTaskDetails$ | async as details" class="mt-2">{{details.description}}</div>
                        </ng-container>
                    </div>
                    <button *ngIf="task.Status !== 2; else completedTask" mat-flat-button color="accent" class="task-mark-as-done-btn mr-2 mt-2" (click)="completeTask(task, i)"><i class="fa fa-check-circle mr-2" aria-hidden="true"></i><span i18n="my day mark task as done@@my-day-mark-task-as-done">Mark as done</span></button>
                    <ng-template #completedTask>
                        <button mat-flat-button disabled color="accent" class="task-mark-as-done-btn mr-2"><i class="fa fa-check-circle mr-2" aria-hidden="true"></i><span i18n="my day task completed@@my-day-task-completed">Completed</span></button>
                    </ng-template>
                    <a mat-flat-button href="{{task.Url}}" class="mr-2 mt-2 details-btn"><span i18n="my day task details@@my-day-task-details">Task details</span></a>
                </ng-template>
            </mat-expansion-panel>
            <app-action-button (clickEvent)="toggleShowMore()" *ngIf="tasks.length > showLessTasksCount">
                <span *ngIf="showMore === showLessTasksCount" i18n="show more tasks@@show-more-tasks">Show more tasks</span>
                <i *ngIf="showMore === showLessTasksCount" class="ml-2 ms-Icon ms-Icon--ChevronDown align-bottom" aria-hidden="true"></i>
                <span *ngIf="showMore > showLessTasksCount" i18n="show less tasks@@show-less-tasks">Show less tasks</span>
                <i *ngIf="showMore > showLessTasksCount" class="ml-2 ms-Icon ms-Icon--ChevronUp align-bottom" aria-hidden="true"></i>
            </app-action-button>
        </mat-accordion>

        <!-- no tasks found-->
        <mat-accordion *ngIf="!tasks || !tasks.length" class="left mr-2 w-50">
            <div class="d-md-flex justify-content-start mb-md-3">
              <span class="mr-1" i18n="@@your-day-tasks-from">Tasks from </span>
              <app-action-link [href]="plannerLink" [target]="'blank'">
                  <span i18n="@@your-day-planner">Planner</span>
              </app-action-link>
              <span class="ml-1 mr-1" i18n="@@your-day-and">and</span>
              <app-action-link [href]="todoLink" [target]="'blank'">
                <span  i18n="@@your-day-todo">To do</span>
              </app-action-link>
            </div>

            <div class="d-md-flex justify-content-start mb-md-3">
                <span i18n="your day create tasks@@your-day-create-tasks-description">You have no tasks today, create new ones using the links below:</span>
            </div>

            <app-action-link [href]="todoLink" [target]="'blank'">
                <div>
                    <span i18n="your day create tasks todo@@your-day-create-tasks-todo">To-Do</span><i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
                </div>
            </app-action-link>

            <app-action-link [href]="plannerLink" [target]="'blank'">
                <div>
                    <span i18n="your day create tasks planner@@your-day-create-tasks-planner">Planner</span><i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
                </div>
            </app-action-link>
        </mat-accordion>


        <!-- events -->
        <mat-accordion *ngIf="events && events.length" class="right ml-2 w-50 mt-3 mt-md-0 events-list">
            <div class="d-md-flex justify-content-start mb-3 mt-5 mt-md-0">
                <app-action-link [href]="calendarLink" [target]="'blank'">
                    <span i18n="your day events subheader@@gyour-day-events-subheader">Events</span>
                </app-action-link>
            </div>
            <mat-expansion-panel *ngFor="let event of events; let i = index" class="event mb-3 mt-md-0" [class.mt-3]="i === 0">
                <mat-expansion-panel-header [class.completed]="event.Expired">
                    <mat-panel-title>
                        <div>
                            <i class="fa fa-calendar mr-2 event-icon"></i>
                            <span class="font-weight-bold" *ngIf="event.IsAllDay; else starttime" i18n="event allday@@event-allday">(All day)</span>
                            <ng-template #starttime>
                                <span class="font-weight-bold"><abbr title="{{event.EventStartDateFormatted}}">{{event.EventStartDateFormatted}}</abbr></span>
                            </ng-template>
                            <span class="ml-2" data-hj-suppress>{{event.Subject}}</span>
                        </div>
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <div>
                        {{BodyPreview}}
                        <div>
                            <div *ngIf="event.Location"><span><i i18n-aria-label="event-location" aria-label="Event location" role="img" alt="Location" class="fa fa-map-marker mr-1 event-details-icon"></i> {{event.Location}}</span></div>
                            <div>
                                <span><i i18n-aria-label="event-time" aria-label="Event time" role="img" alt="Clock" class="fa fa-clock-o mr-2 event-details-icon"></i></span>
                                <span *ngIf="event.IsAllDay; else time" i18n="event allday@@event-allday">(All day)</span>
                                <ng-template #time>{{event.EventStartDateFormatted}} - {{event.EventEndDateFormatted}}</ng-template>
                            </div>
                        </div>
                        <div class="mt-2">
                            <div>
                                <span>{{event.Accepted}} attending</span>
                                <span class="ml-2" *ngIf="event.Declined">{{event.Declined}} declined</span>
                                <span class="ml-2" *ngIf="event.NoResponse">{{event.NoResponse}} not responded</span>
                                <span class="ml-2" *ngIf="event.Tentative">{{event.Tentative}} tentative</span>
                            </div>
                            <ng-container *ngIf="event.UserPhotos$ | async as photos">
                                <div *ngIf="photos.length > 0" class="position-relative event-users d-inline-block">
                                    <ng-container *ngFor="let photo of photos; index as i">
                                        <div class="position-absolute event-user-image border-1" [ngStyle]="getImageSpacing(i)">
                                            <img *ngIf="photo && photo.indexOf('@') === -1; else letters" class="user-image align-self-center rounded-circle" data-hj-suppress [attr.src]="photo | safe: 'url'" />
                                            <ng-template #letters>
                                                <div class="user-image bg-subtle-color letters align-self-center rounded-circle position-relative d-inline-block align-middle mb-0">
                                                    <span class="letters-text text-uppercase" data-hj-suppress>{{ getPreferredNameLetters(photo) }}</span>
                                                </div>
                                            </ng-template>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                        <div class="mt-2">
                            <span class="event-response d-block d-md-inline-block mt-2 mt-md-0" *ngIf="!event.IsOrganizer && !event.IsCancelled">
                                <button mat-flat-button [class.active]="event.Response === 2" class="subtle-button-color mr-1" (click)="acceptEvent(event, i, events)"><span i18n="my day event response yes@@my-day-event-response-yes">Yes</span></button>
                                <button mat-flat-button [class.active]="event.Response === 3" class="subtle-button-color mr-1" (click)="tentativeAcceptEvent(event, i, events)"><span i18n="my day event response maybe@@my-day-event-response-maybe">Maybe</span></button>
                                <button mat-flat-button [class.active]="event.Response === 4" class="subtle-button-color mr-1" (click)="declineEvent(event, i, events)"><span i18n="my day event response no@@my-day-event-response-no">No</span></button>
                            </span>
                            <span class="event-response d-block d-md-inline-block mt-2 mt-md-0" *ngIf="event.IsCancelled">
                                <button mat-flat-button class="subtle-button-color mr-2" (click)="deleteEvent(event, i, events)"><span i18n="my day event response remove@@my-day-event-response-remove">Remove from calendar</span></button>
                            </span>
                            <span class="event-response d-block d-md-inline-block mt-2 mt-md-0" *ngIf="event.IsOrganizer && event.Attendees > 0">
                                <button mat-flat-button class="subtle-button-color mr-2" (click)="cancelEvent(event, i, events)"><span i18n="my day event response cancel@@my-day-event-response-cancel">Cancel event</span></button>
                            </span>
                            <span class="event-response d-block d-md-inline-block mt-2 mt-md-0" *ngIf="event.IsOrganizer && event.Attendees === 0">
                                <button mat-flat-button class="subtle-button-color mr-2" (click)="deleteEvent(event, i, events)"><span i18n="my day event response delete@@my-day-event-response-delete">Delete</span></button>
                            </span>
                            <a mat-flat-button href="{{event.WebLink}}" class="mr-2 details-btn mt-2 mt-lg-0 float-lg-right"><span i18n="my day event details@@my-day-event-details">Event details</span></a>
                        </div>
                    </div>
                </ng-template>
            </mat-expansion-panel>
        </mat-accordion>

        <!-- no events found-->
        <mat-accordion *ngIf="!events || !events.length" class="right ml-2 w-50 mt-3 mt-md-0 events-list">
            <div class="d-md-flex justify-content-start mb-3 mt-5 mt-md-0">
                <app-action-link [href]="calendarLink" [target]="'blank'">
                    <span i18n="your day events subheader@@gyour-day-events-subheader">Events</span>
                </app-action-link>
            </div>

            <div class="d-md-flex justify-content-start mb-md-3">
                <div>
                    <span i18n="your day create event@@your-day-create-events-description">Your day is empty, create new events in outlook using the link below:</span>
                </div>
            </div>

            <app-action-link [href]="calendarLink" [target]="'blank'">
                <span i18n="your day create event link@@your-day-create-events-outlook-link">Outlook</span><i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
            </app-action-link>
        </mat-accordion>

    </div>
</div>
